import { render, staticRenderFns } from "./RecordStudentList.vue?vue&type=template&id=deb82616&scoped=true"
import script from "./RecordStudentList.vue?vue&type=script&lang=js"
export * from "./RecordStudentList.vue?vue&type=script&lang=js"
import style0 from "./RecordStudentList.vue?vue&type=style&index=0&id=deb82616&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb82616",
  null
  
)

export default component.exports